import { ResponsiveContainer, AreaChart, Area, YAxis, XAxis, Tooltip, ReferenceLine } from "recharts";

const SERIES = [
  { key: "battery", label: "Batterie", unit: "%", color: "#22C55E", domain: [0, 100] },
  { key: "alt", label: "Altitude (rel.)", unit: "m", color: "#3B82F6", domain: ["auto", "auto"] },
  { key: "speed", label: "Vitesse", unit: "m/s", color: "#A78BFA", domain: [0, "auto"] },
  { key: "signal", label: "Signal 4G", unit: "%", color: "#F59E0B", domain: [0, 100] },
];

function ChartTip({ active, payload, unit }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-[#0A0A0A] border border-white/15 rounded-sm px-2 py-1 font-mono text-[10px]">
      <span className="text-white">{payload[0].value?.toFixed(1)}{unit}</span>
    </div>
  );
}

export default function TelemetryCharts({ history, cursorT }) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {SERIES.map((s) => {
        const last = history.length ? history[history.length - 1][s.key] : null;
        return (
          <div key={s.key} data-testid={`chart-${s.key}`} className="bg-[#0A0A0A] border border-white/10 rounded-sm p-2">
            <div className="flex justify-between items-baseline mb-1">
              <span className="font-mono text-[9px] tracking-[0.15em] uppercase text-[#525252]">{s.label}</span>
              <span className="font-mono text-xs font-bold" style={{ color: s.color }}>
                {last != null ? `${last.toFixed(1)}${s.unit}` : "—"}
              </span>
            </div>
            <div style={{ height: 52, width: "100%", minWidth: 0 }}>
              <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={52} debounce={50}>
                <AreaChart data={history} margin={{ top: 2, right: 0, bottom: 0, left: 0 }}>
                  <defs>
                    <linearGradient id={`g-${s.key}`} x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor={s.color} stopOpacity={0.5} />
                      <stop offset="100%" stopColor={s.color} stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <XAxis dataKey="t" type="number" domain={["dataMin", "dataMax"]} hide />
                  <YAxis hide domain={s.domain} />
                  <Tooltip content={<ChartTip unit={s.unit} />} cursor={{ stroke: "#ffffff22" }} />
                  {cursorT != null && (
                    <ReferenceLine x={cursorT} stroke="#2DD4BF" strokeWidth={1.5} strokeDasharray="3 3" />
                  )}
                  <Area type="monotone" dataKey={s.key} stroke={s.color} strokeWidth={1.5}
                    fill={`url(#g-${s.key})`} isAnimationActive={false} dot={false} />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>
        );
      })}
    </div>
  );
}
